<template>
        <el-dialog :visible.sync="visible" @close="reset" width="35%">
            <template slot="title">
                <p>
                    <span>商品库公开选品</span>
                    <span class="fz-14 yx-color-text-regular ml-6">{{ '(共'+ product_count +'个推广中状态商品)' }}</span>
                </p>
            </template>
            <div class="tipsBox">
                <i class="el-icon-info yx-color-primary"></i>
                <span>非认领达人查看分享链接可自行绑定抖音号创建达人，新建达人会展示在[我的达人]列表”线索状态”</span>
            </div>
            <div class="flex mt-30 flex-align-center flex-just-center">
                <div class="share-img mr-20">
                    <img :src="wxImgUrl" alt="">
                </div>
                <div>
                    <p class="font-bold fz-14 mb-10">您可下载二维码或分享小程序卡片</p>
                    <p class="mb-10 yx-color-text-primary">1、微信扫描二维码;</p>
                    <p class="mb-10 yx-color-text-primary">2、点击页面右下角的“立即分享”按钮;</p>
                    <p class="yx-color-text-primary">3、选择微信联系人分享到会话;</p>
                </div>
            </div>
            <div class="fz-12 yx-color-text-regular mt-20">
                注意：同团队成员打开小程序或扫描二维码可以协助您进行推品，但没有“加入选品表”的操作
            </div>
            <div slot="footer" class="footer-dialog">
                <el-button @click="download">下载二维码</el-button>
                <el-button type="primary" @click="visible = false">完成</el-button>
            </div>
        </el-dialog>
</template>
<script>
export default {
    data() {
        return {
            visible: false,
            wxImgUrl: '',
            product_count: ''
        }
    },
    methods: {
        show(product_count, wxImgUrl) {
            this.product_count = product_count
            this.wxImgUrl = wxImgUrl
            this.visible = true
        },
        reset() {

        },
        download() {
            const image = new Image();
            image.setAttribute("crossOrigin", "anonymous");
            image.onload = function () {
            var canvas = document.createElement("canvas");
            canvas.width = image.width;
            canvas.height = image.height;
            var context = canvas.getContext("2d");
            context.drawImage(image, 0, 0, image.width, image.height);
            var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
            var a = document.createElement("a"); // 生成一个a元素
            var event = new MouseEvent("click"); // 创建一个单击事件
            a.download = '商品库公开选品'; // 设置图片名称
            a.href = url; // 将生成的URL设置为a.href属性
            a.dispatchEvent(event); // 触发a的单击事件
            };
            image.src = this.wxImgUrl;
        }
    }
}
</script>
<style lang="less" scoped>
.tipsBox{
    padding: 10px 16px;
    background-color: #E9F1FF;
    border: 1px solid #BDD5FF;
    margin-bottom: 10px;
}
.share-img{
    width: 200px;
    height: 200px;
}
</style>